import React from "react";
import CategoryPage from "./games/CategoryPage";
import { getGameById } from "../data/gameCatalog";

const dmaGameGroups = [
  { value: "gta", label: "GTA 5", match: (item) => /gta\s*5|gta/i.test(item.name) },
  { value: "warface", label: "Warface", match: (item) => /warface/i.test(item.name) },
  { value: "cs2", label: "CS 2", match: (item) => /cs\s*2/i.test(item.name) },
  { value: "pubg", label: "PUBG", match: (item) => /pubg/i.test(item.name) },
  { value: "war-thunder", label: "War Thunder", match: (item) => /war\s*thunder/i.test(item.name) },
  { value: "cod", label: "COD", match: (item) => /cod|warzone|mw3|bo6|bo7|black\s*ops/i.test(item.name) },
  { value: "arc-raiders", label: "ARC Raiders", match: (item) => /arc\s*raiders/i.test(item.name) },
  { value: "dayz", label: "DayZ", match: (item) => /dayz/i.test(item.name) },
  { value: "fortnite", label: "Fortnite", match: (item) => /fortnite/i.test(item.name) },
  { value: "rust", label: "Rust", match: (item) => /rust/i.test(item.name) },
  { value: "apex", label: "Apex", match: (item) => /apex/i.test(item.name) },
  { value: "marvel-rivals", label: "Marvel Rivals", match: (item) => /marvel\s*rivals/i.test(item.name) },
  { value: "arma", label: "Arma", match: (item) => /arma/i.test(item.name) },
  { value: "battlefield", label: "Battlefield", match: (item) => /battlefield|battlifeld|battlfield/i.test(item.name) },
  { value: "hunt", label: "Hunt", match: (item) => /hunt/i.test(item.name) },
  { value: "eft", label: "EFT", match: (item) => /eft/i.test(item.name) },
  { value: "rainbow-six", label: "Rainbow Six", match: (item) => /rainbow\s*six/i.test(item.name) },
  { value: "valorant", label: "Valorant", match: (item) => /valorant/i.test(item.name) },
  { value: "hardware", label: "Hardware", match: (item) => /card|fuser|kmbox/i.test(item.name) },
];

export default function Dma() {
  return <CategoryPage game={getGameById("dma")} customGroups={dmaGameGroups} customGroupLabel="DMA games" />;
}
